module.exports = __webpack_public_path__ + "static/media/google.e4c4ef54.svg";